import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { LuCheck } from "react-icons/lu";

const FilterBoxTile = ({
  label,
  subtitle,
  selected = false,
  onClick,
  badge,
  icon: Icon,
  minWidth = "70px",
}) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  return (
    <Box
      onClick={onClick}
      sx={{
        position: "relative",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "10px 14px",
        minWidth: minWidth,
        borderRadius: "8px",
        cursor: "pointer",
        userSelect: "none",
        border: selected
          ? `2px solid ${isDark ? "#4ade80" : "#16a34a"}`
          : `1px solid ${isDark ? "#3f3f46" : "#cbd5e1"}`,
        backgroundColor: selected
          ? isDark
            ? "rgba(74, 222, 128, 0.12)"
            : "rgba(22, 163, 74, 0.08)"
          : isDark
            ? "#1f1f23"
            : "#ffffff",
        boxShadow: selected
          ? `0 2px 8px ${isDark ? "rgba(74, 222, 128, 0.2)" : "rgba(22, 163, 74, 0.15)"}`
          : "none",
        transition: "all 0.15s ease-in-out",
        "&:hover": {
          borderColor: selected
            ? isDark
              ? "#4ade80"
              : "#16a34a"
            : isDark
              ? "#71717a"
              : "#94a3b8",
          backgroundColor: selected
            ? isDark
              ? "rgba(74, 222, 128, 0.18)"
              : "rgba(22, 163, 74, 0.12)"
            : isDark
              ? "#27272a"
              : "#f8fafc",
          transform: "translateY(-1px)",
        },
      }}
    >
      {selected && (
        <Box
          sx={{
            position: "absolute",
            top: 4,
            right: 4,
            width: 14,
            height: 14,
            borderRadius: "50%",
            backgroundColor: isDark ? "#4ade80" : "#16a34a",
            color: "#ffffff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <LuCheck size={10} strokeWidth={3} />
        </Box>
      )}

      {Icon && (
        <Box
          sx={{
            color: selected
              ? isDark
                ? "#4ade80"
                : "#16a34a"
              : isDark
                ? "#94a3b8"
                : "#64748b",
            mb: 0.5,
            display: "flex",
            alignItems: "center",
          }}
        >
          <Icon size={18} />
        </Box>
      )}

      <Typography
        sx={{
          fontFamily: "Poppins, sans-serif",
          fontSize: "13px",
          fontWeight: selected ? 600 : 500,
          color: selected
            ? isDark
              ? "#4ade80"
              : "#16a34a"
            : isDark
              ? "#f4f4f5"
              : "#1e293b",
          textAlign: "center",
          lineHeight: 1.2,
        }}
      >
        {label}
      </Typography>

      {subtitle && (
        <Typography
          sx={{
            fontFamily: "Poppins, sans-serif",
            fontSize: "11px",
            color: isDark ? "#94a3b8" : "#64748b",
            mt: 0.25,
            textAlign: "center",
          }}
        >
          {subtitle}
        </Typography>
      )}

      {badge !== undefined && badge !== null && (
        <Box
          sx={{
            mt: 0.5,
            px: 0.75,
            py: 0.1,
            borderRadius: "4px",
            fontSize: "10px",
            fontWeight: 600,
            backgroundColor: selected
              ? isDark
                ? "rgba(74, 222, 128, 0.25)"
                : "rgba(22, 163, 74, 0.2)"
              : isDark
                ? "#27272a"
                : "#e2e8f0",
            color: selected
              ? isDark
                ? "#4ade80"
                : "#15803d"
              : isDark
                ? "#a1a1aa"
                : "#475569",
          }}
        >
          {badge}
        </Box>
      )}
    </Box>
  );
};

export default FilterBoxTile;
